import { IPagination } from 'app/types/common';

export interface ITeamPaymentCollectionsState {
  readonly teamPaymentCollectionsById?: any;
  readonly teamPaymentCollectionIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly showAddTeamPaymentCollection?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationTeamPaymentCollectionIds?: string[];
  readonly currentTeamPaymentCollectionId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface ITeamPaymentCollectionsSelector extends ITeamPaymentCollectionsState {
  readonly currentTeamPaymentCollection?: any;
  readonly currentFormTeamPaymentCollection?: any;
  readonly getTeamPaymentCollectionsFilteredByTagInSelectFormat?: any;
  readonly teamPaymentCollectionsByIdInSelectFormat?: any;
}

export enum TeamPaymentCollectionsActionTypes {
  GET_ALL_TEAM_PAYMENT_COLLECTIONS_REQUESTED = 'redux-app/team-payment-collections/GET_ALL_TEAM_PAYMENT_COLLECTIONS_REQUESTED',
  GET_ALL_TEAM_PAYMENT_COLLECTIONS_PENDING = 'redux-app/team-payment-collections/GET_ALL_TEAM_PAYMENT_COLLECTIONS_PENDING',
  GET_ALL_TEAM_PAYMENT_COLLECTIONS_SUCCESS = 'redux-app/team-payment-collections/GET_ALL_TEAM_PAYMENT_COLLECTIONS_SUCCESS',
  GET_ALL_TEAM_PAYMENT_COLLECTIONS_FAIL = 'redux-app/team-payment-collections/GET_ALL_TEAM_PAYMENT_COLLECTIONS_FAIL',
  GET_TEAM_PAYMENT_COLLECTION_REQUESTED = 'redux-app/team-payment-collections/GET_TEAM_PAYMENT_COLLECTION_REQUESTED',
  GET_TEAM_PAYMENT_COLLECTION_PENDING = 'redux-app/team-payment-collections/GET_TEAM_PAYMENT_COLLECTION_PENDING',
  GET_TEAM_PAYMENT_COLLECTION_SUCCESS = 'redux-app/team-payment-collections/GET_TEAM_PAYMENT_COLLECTION_SUCCESS',
  GET_TEAM_PAYMENT_COLLECTION_FAIL = 'redux-app/team-payment-collections/GET_TEAM_PAYMENT_COLLECTION_FAIL',
  UPDATE_TEAM_PAYMENT_COLLECTION_REQUESTED = 'redux-app/team-payment-collections/UPDATE_TEAM_PAYMENT_COLLECTION_REQUESTED',
  UPDATE_TEAM_PAYMENT_COLLECTION_PENDING = 'redux-app/team-payment-collections/UPDATE_TEAM_PAYMENT_COLLECTION_PENDING',
  UPDATE_TEAM_PAYMENT_COLLECTION_SUCCESS = 'redux-app/team-payment-collections/UPDATE_TEAM_PAYMENT_COLLECTION_SUCCESS',
  UPDATE_TEAM_PAYMENT_COLLECTION_FAIL = 'redux-app/team-payment-collections/UPDATE_TEAM_PAYMENT_COLLECTION_FAIL',
  CREATE_TEAM_PAYMENT_COLLECTION_REQUESTED = 'redux-app/team-payment-collections/CREATE_TEAM_PAYMENT_COLLECTION_REQUESTED',
  CREATE_TEAM_PAYMENT_COLLECTION_PENDING = 'redux-app/team-payment-collections/CREATE_TEAM_PAYMENT_COLLECTION_PENDING',
  CREATE_TEAM_PAYMENT_COLLECTION_SUCCESS = 'redux-app/team-payment-collections/CREATE_TEAM_PAYMENT_COLLECTION_SUCCESS',
  CREATE_TEAM_PAYMENT_COLLECTION_FAIL = 'redux-app/team-payment-collections/CREATE_TEAM_PAYMENT_COLLECTION_FAIL',
  DELETE_TEAM_PAYMENT_COLLECTION_REQUESTED = 'redux-app/team-payment-collections/DELETE_TEAM_PAYMENT_COLLECTION_REQUESTED',
  DELETE_TEAM_PAYMENT_COLLECTION_PENDING = 'redux-app/team-payment-collections/DELETE_TEAM_PAYMENT_COLLECTION_PENDING',
  DELETE_TEAM_PAYMENT_COLLECTION_SUCCESS = 'redux-app/team-payment-collections/DELETE_TEAM_PAYMENT_COLLECTION_SUCCESS',
  DELETE_TEAM_PAYMENT_COLLECTION_FAIL = 'redux-app/team-payment-collections/DELETE_TEAM_PAYMENT_COLLECTION_FAIL',
  SELECT_TEAM_PAYMENT_COLLECTION_REQUESTED = 'redux-app/team-payment-collections/SELECT_TEAM_PAYMENT_COLLECTION_REQUESTED',
  CLEAR_TEAM_PAYMENT_COLLECTIONS = 'redux-app/team-payment-collections/CLEAR_TEAM_PAYMENT_COLLECTIONS',
}

export default null;
